module.exports = __webpack_public_path__ + "img/w3_paste_white.e44bb0ad.png";